import { modalRenderer } from '~/modal/modalRendererRegistry';
import { MigrateMapsFinishedComponent } from './migrateMapsFinished.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MigrationFinished: undefined;
  }
}

modalRenderer.register('MigrationFinished', (props) => <MigrateMapsFinishedComponent {...props} />);
